import React, { Component } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
export default class Services extends Component {
    componentDidMount() {
        AOS.init({
            easing: 'ease',
            duration : 2000
        });
    }
    render() {
        return (
            <section className="services" id="services">
                <div className="container">
                    <div className="section-heading">
                        <h1> Skills</h1>
                        <h6>Langages, librairies and frameworks I work with.</h6>
                    </div>
                    <div className="my-skills">
                        <div className="skill" data-aos="fade-right">
                            <div className="icon-container">
                                <i className="fab fa-js-square"></i>
                            </div>
                            <h1>Javascript</h1>
                        </div>
                        <div className="skill" data-aos="fade-down">
                            <div className="icon-container">
                                <i className="fab fa-python"></i>
                            </div>
                            <h1> Python | Django </h1>
                        </div>
                        <div className="skill" data-aos="fade-down">
                            <div className="icon-container">
                                <i className="fab fa-react"></i>
                            </div>
                            <h1> React.js</h1>
                        </div>
                        <div className="skill" data-aos="fade-left">
                            <div className="icon-container">
                                <i className="fab fa-css3"></i>
                            </div>
                            <h1> CSS</h1>
                        </div>
                        <div className="skill" data-aos="fade-right">
                            <div className="icon-container">
                                <i className="fab fa-bootstrap"></i>
                            </div>
                            <h1> Bootstrap 4</h1>
                        </div>
                        <div className="skill" data-aos="fade-up">
                            <div className="icon-container">
                                <i className="fab fa-html5"></i>
                            </div>
                            <h1> HTML</h1>
                        </div>
                        {/* <div className="skill">
                            <div className="icon-container">
                                <i className="fas fa-code"></i>
                            </div>
                            <h1> Algorithm </h1>
                        </div> */}
                        <div className="skill" data-aos="fade-up">
                            <div className="icon-container">
                                <i className="fas fa-database"></i>
                            </div>
                            <h1> PostgreSQL </h1>
                        </div>
                        <div className="skill" data-aos="fade-left">
                            <div className="icon-container">
                                <i className="fas fa-chart-area"></i>
                            </div>
                            <h1> Chart.JS | Plotly </h1>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
